export const groupsOfXeroAccountsApiPaths = <const>{
    groupsOfXeroAccounts: 'companies/:companyId/xero/groups-of-xero-accounts',
    groupOfXeroAccounts: 'companies/:companyId/xero/groups-of-xero-accounts/:groupOfXeroAccountsId',
    groupOfXeroAccountsVersions: 'companies/:companyId/xero/groups-of-xero-accounts/:groupOfXeroAccountsId/versions',
    groupOfXeroAccountsIsArchived:
        'companies/:companyId/xero/groups-of-xero-accounts/:groupOfXeroAccountsId/is-archived',
};
